import React, { useState, useEffect, useRef } from 'react';
import './Payment.css';

import { PageTitle } from '../../../components';

import { FaClipboardCheck, FaMobile, FaLock, FaPenFancy, FaCreditCard, FaRegCreditCard, FaCalendarCheck, FaEnvelope, FaUserAlt } from 'react-icons/fa';
import { SiLine } from 'react-icons/si'; // 從 react-icons 庫導入 LINE 圖標

import Cookies from 'js-cookie';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MessageModal } from '../../../components';
import { Helmet } from 'react-helmet';

import { useTokenCheck, getPaymentInfo, callBindCreditCard, callBindLinePay } from '../../../constants';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const TPDirect = window.TPDirect;// 引入 TapPay SDK

const Payment = () => {
  const { nickName, isCanExecute } = useTokenCheck();

  const navigate = useNavigate();
  // #region 需要密碼，返回要前往會員中心

  const location = useLocation();

  // Louis Add new function: 取得QueryParams
  // 當Query String中的變數action=update, 表示為更新資料

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const queryParams = getQueryParams();
  const [action, setAction] = useState("new");//預設註冊

  useEffect(() => {
    if (queryParams["action"] !== undefined && queryParams["action"] !== "") {
      setAction(queryParams["action"]);
    }
  }, [queryParams]);

  // Louis: 完成傳入參數的檢查


  const [isApiHavePassword, setApiHavePassword] = useState(false);//預設註冊

  //這一頁不會有檢查密碼，放在外面檢查
  // const [validatePassword, setValidatePassword] = useState('');

  // const validatePasswordRef = useRef(null);

  // const handleValidatePasswordChange = (e) => {
  //   const value = e.target.value;
  //   setValidatePassword(value);
  // };

  // const validateLength = (value) => {
  //   return value.trim().length === 0;
  // };


  const setNextPage = () => {
    if (action === "update") {
      navigate("/MemberProfile");
    } else if (action === "new") {
      navigate("/Invoice");
    }
  };

  // #endregion


  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const creditCardRef = useRef(null);
  const linePayRef = useRef(null);

  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };

  useEffect(() => {

    if (!isCanExecute) return;

    // 確保TPDirect已經加載完畢後再進行初始化
    const initializeTPDirect = () => {
      if (window.TPDirect) {
        window.TPDirect.setupSDK(
          18463,
          'app_ko6axKq25K2F541Rpmkl1r0fMRDfjH1cFSMBR90WCdTEoxl24HDFYYVZPlAF',
          'sandbox'  // 'sandbox'測試用 或 'production'正式用
        );

        const rootStyle = getComputedStyle(document.documentElement);
        const mainColor = rootStyle.getPropertyValue('--main-color').trim();
        const greyColor = rootStyle.getPropertyValue('--grey').trim();

        // 初始化卡片欄位
        window.TPDirect.card.setup({
          fields: {
            number: {
              element: '#cardNo', // 卡號欄位
              placeholder: '請輸入信用卡號'
            },
            expirationDate: {
              element: '#cardExpire', // 到期日欄位
              placeholder: '請輸入有效日期'
            },
            ccv: {
              element: '#cardVerify', // CCV 欄位
              placeholder: '請輸入末三碼'
            }
          },
          styles: {
            'input': {
              'color': 'black',
              'background-color': 'rgba(255, 255, 255, 0.5)',
              'font-size': '1.2rem',
              'padding': '1rem',
              'border': '0.1rem solid rgba(59, 59, 59, 0.5)'
            },
            'input::placeholder': {
              'color': greyColor,
              'text-transform': 'capitalize'
            },
            '.valid': {
              'color': mainColor
            },
            '.invalid': {
              'color': 'red'
            }
          },
          // 此設定會顯示卡號輸入正確後，會顯示前四後四碼信用卡卡號
          isMaskCreditCardNumber: true,
          maskCreditCardNumberRange: {
            beginIndex: 4,
            endIndex: 11
          }
        });

      }
    };


    // 檢查TPDirect是否已經加載
    if (window.TPDirect) {
      initializeTPDirect();
    } else {
      // 如果TPDirect還未加載，監聽加載事件
      const script = document.createElement('script');
      script.src = 'https://js.tappaysdk.com/sdk/tpdirect/v5.18.0';
      script.onload = initializeTPDirect;
      document.body.appendChild(script);
    }

    getPaymentInfo().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果
          if (payload.data == null) {
            // 設置預設選中
            if (creditCardRef.current) {
              creditCardRef.current.checked = true;
              setPaymentType('credit-card');
            }
          } else if (payload.data != null) {

            if (payload.data.type === "CREDITCARD") {
              if (creditCardRef.current) {
                creditCardRef.current.checked = true;
                setPaymentType('credit-card');
              }
            }

            if (payload.data.type === "LINE") {
              if (linePayRef.current) {
                linePayRef.current.checked = true;
                setPaymentType('line-pay');
              }
            }

          }
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  }, [isCanExecute]);

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior


    if (paymentType === 'line-pay') {
      window.TPDirect.linePay.getPrime(function (result) {
        // alert('get linePay prime 成功，prime: ' + result.prime)

        if (result.prime !== undefined) {
          let data = {
            'prime': result.prime
          }

          callBindLinePay(data).then(payload => {
            const isPayloadValid =
              payload?.status !== undefined &&
              payload?.errorCode !== undefined &&
              payload?.data !== undefined &&
              payload?.errorMessage !== undefined;

            if (isPayloadValid) {
              let errorMessage = payload.errorMessage;

              if (payload.status === 0 && payload.errorCode === '0000') {
                // 處理結果
                setNextPage();
              } else if (payload.status === 1 &&
                (payload.errorCode === '9997' || payload.errorCode === '9998')) {
                //未登入
                let errorMessage = "Token過期，或發生異常，需要重新登入！";
                MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
              } else if (payload.status === 1 && payload.errorCode === '9996') {
                //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
                let errorMessage = "查無此會員，或發生異常，需要重新登入！";
                MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
              } else {
                let errorMessage = payload.errorMessage;
                MessageModal.alert(errorMessage);
              }
            }
          }).catch(error => {
            console.error('Error during API call:', error);
          });
        } else {
          MessageModal.alert('TapPay驗證失敗，請稍候再試！');
        }
      })
    } else if (paymentType === 'credit-card') {

      const validateLength = (value) => {
        return value.trim().length === 0;
      };

      if (validateLength(Name)) {
        MessageModal.alert("請填寫持卡人的姓名");
        return;
      }

      if (validateLength(Email)) {
        MessageModal.alert("請填寫Email");
        return;
      }

      // 取得 TapPay Fields 的 status
      const tappayStatus = window.TPDirect.card.getTappayFieldsStatus()

      // 確認是否可以 getPrime
      if (tappayStatus.canGetPrime === false) {

        let errorMessage = '';

        if (tappayStatus.status.number !== 0) {
          errorMessage = errorMessage + '請檢查信用卡號';
          MessageModal.alert(errorMessage);
          return;
        }

        if (tappayStatus.status.expiry !== 0) {
          errorMessage = errorMessage + '請檢查有效日期' + '\n';
          MessageModal.alert(errorMessage);
          return;
        }

        if (tappayStatus.status.ccv !== 0) {
          errorMessage = errorMessage + '請檢查末三碼' + '\n';
          MessageModal.alert(errorMessage);
          return;
        }

        errorMessage = JSON.stringify(tappayStatus);

        MessageModal.alert(errorMessage);
        return;
      }

      // Get prime
      window.TPDirect.card.getPrime((result) => {

        console.log(result)
        // alert('get TPDirect prime 成功，prime: ' + result.card.prime)


        if (result.card.prime !== undefined) {
          let data = {
            'prime': result.card.prime,
            'owner': Name,
            'email': Email,
          }

          callBindCreditCard(data).then(payload => {

            console.log("check callBindCreditCard");
            console.log(payload);

            const isPayloadValid =
              payload?.status !== undefined &&
              payload?.errorCode !== undefined &&
              payload?.errorMessage !== undefined;



            if (isPayloadValid) {
              let errorMessage = payload.errorMessage;

              if (payload.status === 0 && payload.errorCode === '0000') {
                // 處理結果
                setNextPage();
              } else if (payload.status === 1 &&
                (payload.errorCode === '9997' || payload.errorCode === '9998')) {
                //未登入
                let errorMessage = "Token過期，或發生異常，需要重新登入！";
                MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
              } else if (payload.status === 1 && payload.errorCode === '9996') {
                //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
                let errorMessage = "查無此會員，或發生異常，需要重新登入！";
                MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
              } else {
                let errorMessage = payload.errorMessage;
                MessageModal.alert(errorMessage);
              }
            }
          }).catch(error => {
            console.error('Error during API call:', error);
          });
        } else {
          MessageModal.alert('TapPay驗證失敗，請稍候再試！');
        }
        // send prime to your server, to pay with Pay by Prime API .
        // Pay By Prime Docs: https://docs.tappaysdk.com/tutorial/zh/back.html#pay-by-prime-api
      })
    }
    //需要處理API

    // event.target.reset();
  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'綁定支付方式'} page={'payment'} />

      <Helmet>
        <script src="https://js.tappaysdk.com/sdk/tpdirect/v5.18.0"></script>
      </Helmet>

      <section className='payment'>

        {/* Registration Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaRegCreditCard /></div>

          {/* Heading for the register form */}
          <h3>綁定支付方式</h3>
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            {action === "NEW" && <label >請選擇您的支付方式，綁定後您將啟用聰明支付。</label>}
            {action === "update" && <label >當你修改支付方式，TapPay將會重新驗證您的支付驗證成功後才能繼續使用在停車繳費</label>}
          </div>
          {/* paymentType Input */}
          <div className="input-field">
            <label htmlFor="paymentType"><FaPenFancy /></label>
            <div className="box">
              <input type="radio" className="radioBox"
                value="credit-card" name="paymentType"
                onChange={handlePaymentTypeChange}
                ref={creditCardRef}
              />
              <span className="radioIcon" onClick={() => creditCardRef.current.click()}><FaRegCreditCard /></span>
              <span className="radioItem" onClick={() => creditCardRef.current.click()}> 信用卡</span>

              <input type="radio" className="radioBox"
                value="line-pay" name="paymentType"
                onChange={handlePaymentTypeChange}
                ref={linePayRef}
              />
              <span className="radioIcon" onClick={() => linePayRef.current.click()}><SiLine /></span>
              <span className="radioItem" onClick={() => linePayRef.current.click()}> LINE Pay</span>
            </div>
          </div>
          <div className={`line-pay-session ${paymentType === 'line-pay' ? '' : 'hidden'}`} id="linePay-area" >
            <div className="notice">
              <label >您在選擇<span>LinePay</span>綁定聰明繳費付款方式時，請先確認您已經完成開通LinePay支付方式。<br />
                以下是綁定LinePay支付流程，請參考：
              </label>
            </div>
            <div className="notice">
              <label >步驟一：<span>打開Line</span>點選右下方錢包按鈕進入「<span>錢包</span>」功能頁。接著點選左上方的「<span>Line Pay</span>」</label>
            </div>

            <div className="input-field">
              {/* Line Pay brief area  */}
              <img className="line-pay-image" src="/images/line_pay_step1.png" alt="" />
            </div>
            <div className="notice">
              <label >步驟二：<span>點選</span>ˋ註冊卡片</label>進行信用卡綁定
            </div>
            <div className="input-field">
              {/* Line Pay brief area  */}
              <img className="line-pay-image" src="/images/line_pay_step2.png" alt="" />
            </div>
            <div className="notice">
              <label >步驟三：<span>填寫或是拍照卡片</span>完成信用卡綁定Line Pay支付。綁定完成後再回本功能完成綁定支付</label>
            </div>
            <div className="input-field">
              {/* Line Pay brief area  */}
              <img className="line-pay-image" src="/images/line_pay_step3.png" alt="" />
            </div>
          </div>
          <div className={`credit-card-fields ${paymentType === 'credit-card' ? '' : 'hidden'}`}>
            {/* Name Input */}
            <div className="input-field">
              <label htmlFor="name"><FaUserAlt /></label>
              <input type="text" name="name" placeholder="請填寫持卡人的姓名" id="name" className="box"
                value={Name} onChange={handleNameChange} />
            </div>
            {/* Email Input */}
            <div className="input-field">
              <label htmlFor="email"><FaEnvelope /></label>
              <input type="text" name="email" placeholder="請填寫Email" id="email" className="box"
                value={Email} onChange={handleEmailChange} />
            </div>
            {/* CreditcardNo Input */}
            <div className="input-field">
              <label htmlFor="cardNo"><FaCreditCard /></label>
              <div id="cardNo" className="box"></div>
            </div>
            {/* cardExpire Input */}
            <div className="input-field">
              <label htmlFor="cardExpire"><FaCalendarCheck /></label>
              <div id="cardExpire" className="box"></div>
            </div>
            {/* cardVerify Input */}
            <div className="input-field">
              <label htmlFor="cardVerify"><FaClipboardCheck /></label>
              <div id="cardVerify" className="box"></div>
            </div>
          </div>

          {/* submit Button */}
          {/* <Link to='/PlateSetting'></Link> */}
          <button name='submit' id='submit' className='btn'>填寫完成</button>
          {action === "new" && <Link to="/Invoice" ><button name='ignore' id='ignore' className='btn'>暫時不設定</button></Link>}
          {action === "update" && <Link to="/MemberProfile"><button name='ignore' id='ignore' className='btn'>回到會員中心</button></Link>}
        </form>

      </section>
    </>
  );
}

export default Payment;